module.exports = __webpack_public_path__ + "assets/Pi.5a4919603859a60cabd8317aa75c4ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Pi.png
// module id = 795
// module chunks = 0